import { AfterViewInit, Component, OnDestroy, OnInit,ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { ErrorService } from 'src/app/shared/services/errors.service';
import { ApiServiceEjecutive } from '../../../apis/ApiServiceEjecutive';
import Swal from 'sweetalert2';
import { FormatDataTableScroll, FormatDataTableScrollOne } from '../../../util/formatDataTable';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as moment from 'moment';

@Component({
  selector: 'app-forecast-detail',
  templateUrl: './forecast-detail.component.html',
  styleUrls: ['./forecast-detail.component.scss']
})
export class ForecastDetailComponent implements AfterViewInit, OnDestroy, OnInit {

  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtTrigger = new Subject();
  dtOptions: DataTables.Settings = {};
  formSearch:FormGroup
  listInfOption = [];
  listInfoPlay = [];
  dateGarfi = [];
  payPaidGarfi = [];
  payLateGarfi = [];
  payPendingGarfi = [];
  listFilterClient = [];
  listPlayOption = [];


  dropdownSettings = {};
  filterOperation = [];
  filterComercialOrigen = [];
  typeMoney = ""
  listTypeService = [];


  constructor(
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private errorService:ErrorService,
    private apiService: ApiServiceEjecutive) { 

  }

  ngOnInit(): void {
    this.formSearch = this.fb.group({
      end_date:[''],
      start_date:[''],
      optionTypePay: 0,
      optionClient:0,
      selectComercialOrigen: [''],
      selectOperation: [''],
      optionTypeService: [''],
      currencyTransf: 0,
      });

      if (localStorage.getItem("info-pdg-table-detail") ){
          let rs = JSON.parse(localStorage.getItem("info-pdg-table-detail"));
          rs.end_date = moment( rs.end_date, "DD-MM-YYYY").format("YYYY-MM")
          rs.start_date = moment( rs.start_date, "DD-MM-YYYY").format("YYYY-MM")
          this.formSearch.patchValue(rs);
          
      }
      let start_date = "";
      let end_date = "";
      if(this.formSearch.value.end_date != "" && this.formSearch.value.start_date != ""){
        start_date = moment( this.formSearch.value.start_date, 'YYYY-MM').format("DD-MM-YYYY")
        end_date = moment( this.formSearch.value.end_date, 'YYYY-MM').format("DD-MM-YYYY")
      }

    this.dtOptions = FormatDataTableScrollOne(); 
    this.iniService(start_date, end_date)
  }

  iniService(startDataSw, endDataSw){


    let infoModeny = this.formSearch.value.currencyTransf
    if(infoModeny == 0){
      infoModeny = "2"
    }
 
    this.spinner.show();
    this.apiService.getService('list-headship-pay-detail?startDataSw='+startDataSw+'&endDataSw='+endDataSw+'&typePay='+this.formSearch.value.optionTypePay+'&clientId='+this.formSearch.value.optionClient+'&commercialOrigin='+this.formSearch.value.selectComercialOrigen+'&operation='+this.formSearch.value.selectOperation+'&serviceType='+this.formSearch.value.optionTypeService+'&currencyTransf='+infoModeny+'')
    .subscribe({
      next: (rs: any) => {
      if (rs.code == null) {

        if(this.listTypeService.length == 0){
          this.listTypeService = rs.listServiceType
          this.filterComercialOrigen = rs.listCommercialOrigin
          this.filterOperation = rs.listOperation
          this.listPlayOption = rs.listPlayOption
          this.listFilterClient = rs.listFilterClient
        }

      this.listInfOption = rs.listOption
      this.listInfoPlay = rs.listInfoPlay

      this.spinner.hide();

      this.rerender();


    let type = this.listPlayOption.filter( n =>  n.id ==  this.formSearch.value.currencyTransf)
    if(type[0] != null){
      this.typeMoney = type[0].name
    }else{
      this.typeMoney = "UF"
    }

      } else {
        this.spinner.hide();
        Swal.fire({
          title:  rs.error,
          text: '',
          icon: 'error',
          heightAuto: false
          });
      }
    },
    error: (error) => {
      this.errorService.error(error);
    },
  });
  }



  ngAfterViewInit(): void {
    
  }

  limpButton(){
    location.replace(`/pdg/headship/forecast-detail`)
      
  }

  formSubmit(){


    let start_date = "";
    let end_date = "";

    if(this.formSearch.value.end_date == "" && this.formSearch.value.start_date == ""){
      
      this.listInfOption = []
      this.listInfoPlay = []
      this.rerender()
      this.iniService(start_date, end_date);

    }else if(this.formSearch.value.end_date != "" && this.formSearch.value.start_date != ""){
      start_date = moment( this.formSearch.value.start_date, 'YYYY-MM').format("DD-MM-YYYY")
      end_date = moment( this.formSearch.value.end_date, 'YYYY-MM').format("DD-MM-YYYY")

      let inf = {
        start_date: start_date,
        end_date: end_date,
        optionTypePay: this.formSearch.value.optionTypePay,
        optionState: this.formSearch.value.optionState,
        optionClient: this.formSearch.value.optionClient,
      }

      localStorage.setItem("info-pdg-table-detail", JSON.stringify(inf));
      location.replace(`/pdg/headship/forecast-detail`)
    }else{
      Swal.fire({title: 'Debe seleccionar fecha incio y termino o dejarla en blanco' ,text: '',icon: 'error',heightAuto: false});
      return;
    }

  }



  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtTrigger.next();
  }
}


